(function () {
    'use strict';

    class LeadsInsightsInsightController extends Controllers.BaseControllerES6 {

        // @ngInject
        constructor(
            $scope,
            $injector,
            Enums,
            $translate
        ) {
            super($scope, $injector);
            this.__objectType = 'LeadsInsightsInsightController';
            this.LOCKED = Enums.leadsInsightsStates.locked;
            this.COLLECTING = Enums.leadsInsightsStates.collecting;
            this.RESULTS = Enums.leadsInsightsStates.results;

            this.translatedExplanation = $translate.instant(this.explanation)
          }
    }

    Components.LeadsInsightsInsight = {
        bindings: {
            value: '<',
            unit: '@',
            explanation: '@',
            state: '<',
            onCtaClick: '&'
        },
        transclude: {
            subValue: '?subValue'
        },
        controller: LeadsInsightsInsightController,
        templateUrl: 'angular/app/modules/core/features/pipeline/leads_insights/leads_insights_insight_template.html',
    };

}());